import React, { useState, useEffect } from 'react';
import CustomInput from '../../Utility/Components/CustomInput';
import ErrorBoundary from '../../Utility/Components/ErrorBoundary';
import { walinerSettingPatch, walinerSettingPost } from '../Controller/OrganizationController';
import Utility from "../../Utility/Utility";


function WalinerTemplateModalContent(props) {
    const [templateList, setTemplateList] = useState([]);
    const [errorList, setErrorList] = useState([]);
    const [isExistingRecord, setIsExistingRecord] = useState(false);

    useEffect(() => {
        const data = props.formData?.data?.[0]?.WhatsappTemplateMapping_data;
        if (data && data.length > 0) {
            const orgRecords = data.filter(item => item.org_id === props.orgId);
            if (orgRecords.length > 0) {
                setTemplateList(orgRecords.map(item => ({ ...item })));
                setErrorList(orgRecords.map(() => ({ template_name: "" })));
                setIsExistingRecord(true);
            } else {
                const defaultRecords = data.filter(item => item.org_id === 0);
                setTemplateList(defaultRecords.map(item => ({ ...item, template_name: "" })));
                setErrorList(defaultRecords.map(() => ({ template_name: "" })));
                setIsExistingRecord(false);
            }
        }
    }, [props.formData]);

    const handleChange = (value, idx) => {
        const updated = [...templateList];
        updated[idx] = { ...updated[idx], template_name: value };
        setTemplateList(updated);
        const updatedErrors = [...errorList];
        updatedErrors[idx] = { template_name: "" };
        setErrorList(updatedErrors);
    };

    const validate = () => {
        let valid = true;
        const errors = templateList.map(item => {
            if (!item.template_name || !item.template_name.trim()) {
                valid = false;
                return { template_name: "Required Field" };
            }
            return { template_name: "" };
        });
        setErrorList(errors);
        return valid;
    };

    const handleSave = () => {
        if (!validate()) return;
        const { loaderStateTrue, loaderStateFalse, onClose } = props;
        if (loaderStateTrue) loaderStateTrue();
        if (isExistingRecord) {
            const formatData = [
                {
                    resource_name: "WhatsappTemplateMapping",
                    column_value_pair: templateList.map(({ id, org_id, template_type, template_name }) => ({
                        id, org_id, template_type, template_name: template_name.trim()
                    }))
                }
            ];
            walinerSettingPatch(null, formatData ).then(res => {
                if (loaderStateFalse) loaderStateFalse();
                if (res && res[0].data[0].success) {
                    Utility.toastNotifications(res.message || "Updated successfully", "Success", "success");
                    if (onClose) onClose();
                } else {
                    Utility.toastNotifications(res?.message || "Update failed", "Error", "error");
                }
            }).catch(err => {
                if (loaderStateFalse) loaderStateFalse();
                Utility.toastNotifications(err?.message || "Something went wrong", "Error", "error");
            });
        } else {
            const formatData = [
                {
                    resource_name: "WhatsappTemplateMapping",
                    column_value_pair: templateList.map(({ template_type, template_name }) => ({
                        template_type, template_name: template_name.trim(), org_id: props.orgId
                    }))
                }
            ];
            walinerSettingPost( formatData ).then(res => {
                if (loaderStateFalse) loaderStateFalse();
                if (res && res[0].success) {
                    Utility.toastNotifications(res.message || "Saved successfully", "Success", "success");
                    if (onClose) onClose();
                } else {
                    Utility.toastNotifications(res?.message || "Save failed", "Error", "error");
                }
            }).catch(err => {
                if (loaderStateFalse) loaderStateFalse();
                Utility.toastNotifications(err?.message || "Something went wrong", "Error", "error");
            });
        }
    };

    return (
        <div className="gridcontainer">
            <div className="modalinnerbody" style={{marginRight: 10}}>
                <div className="innerbodydimension">
                    <div className="col-md-12">
                        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                                <tr>
                                    <th style={thStyle}>Template Type</th>
                                    <th style={thStyle}>Template Name <span style={{ color: 'red' }}>*</span></th>
                                </tr>
                            </thead>
                            <tbody>
                                {templateList.map((item, idx) => (
                                    <tr key={idx}>
                                        <td style={tdStyle}>
                                            <span style={{ fontSize: '13px', color: '#555' }}>{item.template_type}</span>
                                        </td>
                                        <td style={tdStyle}>
                                            <ErrorBoundary title="TemplateInput Error">
                                                <input
                                                    type="text"
                                                    value={item.template_name}
                                                    onChange={(e) => handleChange(e.target.value, idx)}
                                                    style={inputStyle}
                                                />
                                                {errorList[idx]?.template_name && (
                                                    <div className="errorClass error_div" style={{ fontSize: '11px', color: 'red' }}>
                                                        {errorList[idx].template_name}
                                                    </div>
                                                )}
                                            </ErrorBoundary>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className="col-md-12 text-center topspace">
                    <button type="button" className="modBtnSave" onClick={handleSave}>Save</button>
                    <button type="button" className="modBtnSave cancelbtn" onClick={props.onClose}>Cancel</button>
                </div>
            </div>
        </div>
    );
}

const thStyle = {
    padding: '10px 12px',
    backgroundColor: '#f5f5f5',
    borderBottom: '2px solid #ddd',
    textAlign: 'left',
    fontSize: '13px',
    fontWeight: '600',
    color: '#333'
};

const tdStyle = {
    padding: '8px 12px',
    borderBottom: '1px solid #eee',
    verticalAlign: 'middle'
};

const inputStyle = {
    width: '100%',
    padding: '6px 10px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    fontSize: '13px',
    outline: 'none'
};

export default WalinerTemplateModalContent;
